import { GetRequest } from '../service';
const ControllerName = "RolePriviledges"

export const GetRolesPrivilegesByRoleID = (roleID) => {
    return GetRequest(ControllerName + "/" + roleID)
}

